import React from "react";
import { View, Text, Button, Icon, IconsHash } from "ui";
import { styled } from "styles";
import TextInput from "./ui/TextInput";
import { userMutations } from "api";
import { notify } from "shared/services";
import ConfirmDialog from "./ConfirmDialog";

interface P {
  title: string;
  rightText?: string;
  onClick?: () => void;
  confirmPhone?: boolean;
  confirmEmail?: boolean;
  id?: string;
  isPhone?: boolean;
  isEmail?: boolean;
  className?: string;
}
export default class AddContact extends React.Component<P> {
  public state = {
    code: "",
    openDialog: false
  };

  public handleChange = event => {
    this.setState({ code: event.target.value });
  }

  public deleteItem = () => {
    const { openDialog } = this.state;
    let MutationComponentDelete;
    if (this.props.isPhone) {
      MutationComponentDelete = userMutations.DeletePhone;
    } else if (this.props.isEmail) {
      MutationComponentDelete = userMutations.DeleteEmail;
    }
    return (
      <MutationComponentDelete>
        {deleteItem => (
          <ConfirmDialog
            text={
              this.props.isPhone
                ? "Esti sigur ca vrei sa stergi telefonul?"
                : "Esti sigur ca vrei sa stergi acest email?"
            }
            open={openDialog}
            onClose={() => this.setState({ openDialog: false })}
            onConfirm={async () => {
              try {
                await deleteItem({
                  variables: { id: this.props.id }
                });
                notify(
                  this.props.isPhone
                    ? "Telefonul a fost sters."
                    : "Email-ul a fost sters."
                );
              } catch (err) {}
            }}
          />
        )}
      </MutationComponentDelete>
    );
  }

  public render = () => {
    const {
      title,
      rightText,
      onClick,
      confirmPhone,
      confirmEmail,
      isPhone,
      isEmail,
      className
    } = this.props;

    const { openDialog } = this.state;

    let MutationComponentConfirm;

    if (confirmPhone) {
      MutationComponentConfirm = userMutations.ConfirmPhone;
    }
    if (confirmEmail) {
      MutationComponentConfirm = userMutations.ConfirmEmail;
    }

    return (
      <Config
        flexDirection="column"
        bg="grey"
        mb={1}
        mt={1}
        borderRadius={10}
        flexWrap="nowrap"
        onClick={onClick}
        className={className}
      >
        <View
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          p={2}
        >
          <View flexDirection="row" alignItems="center" flex={2}>
           <Text ml={2} color="white" fontSize={3}>
              {title}
            </Text>
          </View>
          <View flexDirection="row" alignItems="center">
          {!rightText && (
              <Button
                p={0}
                mr={2}
                bg="grey"
                onClick={() => this.setState({ openDialog: true })}
              >
                <Icon name="close" size={1.5} color="white" />
              </Button>
            )}
            {openDialog && this.deleteItem()}
            {!!rightText && (
              <Text
                color="white"
                fontSize={3}
                mr={2}
                flex={1}
                textAlign="right"
              >
                {rightText}
              </Text>
            )}
          </View>
        </View>
        {(confirmPhone || confirmEmail) && (
          <MutationComponentConfirm>
            {confirm => (
              <form
                onSubmit={async e => {
                  try {
                    e.preventDefault();
                    const { code } = this.state;
                    await confirm({
                      variables: { id: this.props.id, code }
                    });
                    notify(
                      confirmPhone
                        ? "Telefonul a fost confirmat."
                        : "Email-ul a fost confirmat."
                    );
                  } catch (err) {}
                }}
              >
                <View
                  px={3}
                  pb={2}
                  flexDirection="row"
                  justifyContent="space-between"
                >
                  <TextInput
                    width="8rem"
                    height="2rem"
                    onChange={this.handleChange}
                    value={this.state.code}
                    placeholder="Cod de activare"
                  />

                  <View>
                    <Button border="none" as="button">
                      <Icon name="check" size={1.5} color="white" />
                    </Button>
                  </View>
                </View>
              </form>
            )}
          </MutationComponentConfirm>
        )}
      </Config>
    );
  }
}

const Config = styled(View)`
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/components/AddContact.tsx